import { Pipe, PipeTransform } from '@angular/core';

  @Pipe({
    name: 'searchbyId'
  })
  export class SearchIdPipe implements PipeTransform {
    transform(items: any, searchId: string): any[] {
      if(!items) return [];
      if(!searchId) return items;
  
      searchId = searchId.toLowerCase();
      return items.filter( item => {
        return item.id.toLowerCase().includes(searchId) || item.name.toLowerCase().includes(searchId);
      });
    }

}


